import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRequest } from "ahooks";
import { List, Typography } from "antd";
import BasePopup from "./BasePopup";
import { copyTextToClipboard } from "@/utils";
import Message from "@/components/message";
import { useUserInfoStore } from "@/stores";
import Api from "@/service";

import "./index.scss";

interface AwardQueryPopupProps {
  open: boolean;
  onClose: () => void;
}

const AwardQueryPopup: React.FC<AwardQueryPopupProps> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { setAward } = useUserInfoStore();
  // 查询奖励
  const { data } = useRequest(
    async (): Promise<string[]> => {
      const res = await Api.queryAward();
      setAward(res.data.award_records);
      return res.data.award_records?.map((item) => item.cdk) || [];
    },
    {
      ready: open,
    }
  );

  const handleClose = () => {
    onClose();
  };

  const handleCopyAwardCode = (code: string) => {
    copyTextToClipboard(code)
      .then(() => {
        Message.success({
          content: t("copySuccess"),
        });
      })
      .catch(() => {
        Message.error({
          content: t("copyError"),
        });
      });
  };

  const { Text } = Typography;

  const formContent = (
    <div className='code-list share-code-container'>
      <List
        size='small'
        dataSource={data}
        renderItem={(item) => (
          <List.Item onClick={() => handleCopyAwardCode(item)}>
            <Text copyable strong style={{ color: "#1890ff" }}>
              {item}
            </Text>
          </List.Item>
        )}
      />
    </div>
  );

  const tips = (
    <div className='tips'>
      <div>{t("text_6")}</div>
      <div>{t("text_7")}</div>
      <div>{t("text_8")}</div>
    </div>
  );

  return (
    <BasePopup
      open={open}
      tips={tips}
      onClose={handleClose}
      title={t("queryRewards")}>
      {formContent}
    </BasePopup>
  );
};

export default AwardQueryPopup;
